export default __webpack_public_path__ + "static/media/org_phone.f15559e0.svg";